// Amount input holds cents as digits; 9 digits = up to $9,999,999.99
export const CLAIM_AMOUNT_MAX_DIGITS = 9
export const CENTS_PER_DOLLAR = 100

// Kanguro Claims API (pet) upload limits
export const PET_CLAIM_ACCEPTED_FILE_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/heic',
]
export const PET_CLAIM_PICTURE_TYPES = ['image/jpeg', 'image/png', 'image/heic']
export const PET_CLAIM_MAX_FILE_BYTES = 10 * 1024 * 1024
export const PET_CLAIM_MAX_REQUEST_BYTES = 40 * 1024 * 1024
export const PET_CLAIM_MAX_INVOICES = 20
export const PET_CLAIM_DESCRIPTION_MAX_LENGTH = 2000
export const PET_CLAIM_PLEDGE_FILE_NAME = 'pledge-of-honor.png'

// Problem `type` URIs from the Claims API we react to
export const CLAIM_PROBLEM_TYPE = {
  POLICY_NOT_CLAIMABLE:
    'https://api.kanguroseguro.com/problems/policy-not-claimable',
  CLAIM_ALREADY_FILED:
    'https://api.kanguroseguro.com/problems/claim-already-filed',
  CLAIM_NOT_FILEABLE:
    'https://api.kanguroseguro.com/problems/claim-not-fileable',
  CLAIM_FILED_NOT_RECORDED:
    'https://api.kanguroseguro.com/problems/claim-filed-not-recorded',
  INSURANCE_CORE_UNAVAILABLE:
    'https://api.kanguroseguro.com/problems/insurance-core-unavailable',
} as const
// Directus folder where renters claim attachments are stored (same as mobile)
export const RENTERS_CLAIMS_FOLDER_ID = 'f0767649-033d-403c-aa74-cb5d581ed898'
export const US_PHONE_REGEX = /^(\+1)?[2-9]\d{2}[2-9]\d{6}$/
export const PHONE_FORMATTING_CHARS = /[\s()-]/g

export const MISSING_FIELDS_SEPARATOR = ', '

// Only active policies can take new claims
export const ACTIVE_POLICY_STATUS = 'ACTIVE'

// ID card flip animation between claim form steps
export const CARD_FLIP_PERSPECTIVE = 'var(--card-flip-perspective)'
export const CARD_FLIP_TRANSFORM = {
  FLIPPING: 'rotateY(90deg)',
  IDLE: 'rotateY(0deg)',
} as const
